const UIMessage = ({
  type = "info",
  width = "300px",
  centered = true,
  style = { margin: "10px" },
  children,
}) => {
  const currentStyles = { ...style, width: width };
  return (
    <div
      className={`ui ${type} ${centered && "centered"} message`}
      style={currentStyles}
    >
      {children}
    </div>
  );
};

export default UIMessage;
